import ILocale from "./ILocale";

export const EsTranslation: ILocale = {
  home: {
    title: "Hola! soy Facundo Herrera 🚀",
    subtitle: "Tecnico Universitario en Programación | UTN-FRT",
    content: {
      first:
        "Software Developer de Tucumán - Argentina 🍋, graduado de la Universidad Tecnologica Nacional como Tecnico Universitario en Programación.",
      second:
        "Mi perfil tecnico está mayoritariamente compuesto tanto por tecnologias frontend como backend, con competitivos conocimientos en desarollo mobile (hibrido y nativo).",
      third:
        "En el area de Frontend he venido orientado mi career path a Reactjs, con sus versiones más modernas en donde priorizo utilizar hooks, además de manejos de states como Context y Redux. Tambien estoy trabajando con Nextjs en conjunto a Styled components, React query y Context.",
      fourth:
        "En el area de Backend estoy dando especial foco a Nodejs con express y typescript, asi como tambien a Nestjs como framework. Tengo experiencia trabajando con .Net y Laravel en diferentes proyectos de microservicios y monoliticos, manejando consultas SQL y ORMs",
      fifth:
        "Me gusta todo acerca del mundo del software y la tecnologia, usualmente escucho podcast sobre tech news, entre los cuales están",
      six: {
        first: "Para más información podes enviarme un email a",
        second: "también podes leer",
        third: "o contactarte a los link que dejo abajo",
      },
    },
  },
};
